import { useState, useEffect } from "react";
import { Box, IconButton, useTheme } from "@mui/material";
import Slider from "react-slick";
import { ArrowBackIosNew, ArrowForwardIos } from "@mui/icons-material";
import { topClientApi } from "../../API/Api";
import ClientItem from "./ClientItem";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const TopClientConnect = () => {
  const theme = useTheme();
  const [clientData, setClientData] = useState([]);

  useEffect(() => {
    fetch(topClientApi)
      .then((res) => res.json())
      .then((result) => setClientData(result))
      .catch((error) => console.error("Fetch failed:", error));
  }, []);

  const PrevArrow = ({ onClick }) => (
    <IconButton
      onClick={onClick}
      sx={{
        position: "absolute",
        top: "50%",
        left: 0,
        zIndex: 2,
        transform: "translateY(-50%)",
        bgcolor: "#fff",
        boxShadow: 2,
        "&:hover": { bgcolor: theme.palette.grey[200] },
      }}
    >
      <ArrowBackIosNew fontSize="small" />
    </IconButton>
  );

  const NextArrow = ({ onClick }) => (
    <IconButton
      onClick={onClick}
      sx={{
        position: "absolute",
        top: "50%",
        right: 0,
        zIndex: 2,
        transform: "translateY(-50%)",
        bgcolor: "#fff",
        boxShadow: 2,
        "&:hover": { bgcolor: theme.palette.grey[200] },
      }}
    >
      <ArrowForwardIos fontSize="small" />
    </IconButton>
  );

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          arrows: false,
        },
      },
    ],
  };

  return (
    <Box sx={{ width: "100%", px: { xs: 1, sm: 2, md: 4 }, mt: 5 }}>
      <Slider {...settings}>
        {clientData?.map((client) => (
          <Box key={client.refer} sx={{ px: 1 }}>
            <ClientItem clientData={client} />
          </Box>
        ))}
      </Slider>
    </Box>
  );
};

export default TopClientConnect;
